var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovedBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 9,
    viewBox: "0 0 24 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.11181 8.06297C2.14372 8.06297 0.535767 6.45497 0.535767 4.48693C0.535767 2.51889 2.14376 0.910889 4.11181 0.910889C6.07972 0.910889 7.68772 2.51889 7.68772 4.48693C7.68772 6.45497 6.07972 8.06297 4.11181 8.06297Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.84775 5.85477C3.77577 5.85477 3.72772 5.83083 3.67967 5.78278L3.05571 5.03883C2.98373 4.9429 2.98373 4.79876 3.07965 4.72678C3.17558 4.65479 3.31972 4.65479 3.3917 4.75072L3.82362 5.2548L5.2637 3.0468C5.33569 2.95087 5.45573 2.92677 5.57576 2.97481C5.67168 3.0468 5.69579 3.16684 5.64774 3.28687L4.0637 5.73491C3.99171 5.80673 3.91974 5.85477 3.84775 5.85477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.3277 2.42273H7.56775C7.92785 2.99877 8.16775 3.71864 8.16775 4.48673C8.16775 5.25482 7.95179 5.97469 7.56775 6.55073H23.4797V2.42273H22.3277Z",
    fill: "#A0AEC0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedBy);
export default __webpack_public_path__ + "static/media/ApprovedBy.a76b3baea8a59dbc32b063cbd0fd55e6.svg";
export { ForwardRef as ReactComponent };